import * as actionTypes from "auth/authActionTypes";
import { head } from "ramda";
import { hasAdminRole } from "auth/authUtils";

const initialState = {
  user: {},
  currentOrganization: null,
  oAuthCode: null,
  redirectPath: "/",
  errorMessage: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOG_IN:
      return Object.assign({}, initialState, {
        oAuthCode: action.oAuthCode,
        redirectPath: action.redirectPath,
      });

    case actionTypes.SET_USER:
      return Object.assign({}, initialState, {
        user: action.user,
        currentOrganization: hasAdminRole(action.user)
          ? null
          : head(action.user.organizations || []),
      });

    case actionTypes.SET_CURRENT_ORGANIZATION:
      return Object.assign({}, state, {
        currentOrganization: action.organization,
      });

    case actionTypes.AUTH_ERROR:
    case actionTypes.DELETE_USER:
      console.log("Removing user from state =======================>");
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default authReducer;
